import { faCircleNotch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Toolbar from "components/Toolbar";
import AuthContext from "context/AuthContext";
import useToastContext from "hooks/useToastContext";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import OtpInput from "react18-input-otp";
import { apiPost } from "utils/apiFetch";
import pathObj from "utils/apiPath";
import { generateRandomID } from "utils/reusableMethods";

function LoginOtp() {
  const { t } = useTranslation();
  const location = useLocation();
  const notification = useToastContext();
  const navigate = useNavigate();
  const [seconds, setSeconds] = useState(59);
  const [minutes, setMinutes] = useState(0);
  const [loading, setLoading] = useState(false);
  const [otpId, setOtpId] = useState("");
  const { setUser, getProfile, storeTokens } = useContext(AuthContext);

  let timerRef;
  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    timerRef = setInterval(() => {
      if (minutes >= 0) {
        if (seconds === 0) {
          if (minutes > 0) {
            setSeconds(60);
            setMinutes((prev) => prev - 1);
          } else {
            setSeconds(0);
          }
        } else {
          setSeconds((prev) => prev - 1);
        }
      } else {
        clearInterval(timerRef);
      }
    }, 1000);
    return () => clearInterval(timerRef);
  });

  const [otp, setOtp] = useState({
    otp_phone: null,
  });

  const [isEmailFocused, setIsEmailFocused] = useState(false);
  useEffect(() => {
    if (otp?.otp_phone?.length === 4 && isEmailFocused === false) {
      const emailOtpElement = document.getElementById("emailOtpInput-0");
      emailOtpElement?.focus();
      setIsEmailFocused(true);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [otp]);

  const validation = () => {
    if (otp.otp_phone) {
      return true;
    } else if (!otp.otp_phone) {
      notification.error("Please, enter phone otp");
      return false;
    } else {
      notification.error("Please, enter phone otp");
      return false;
    }
  };

  const handleSubmit = async () => {
    const isValid = validation();
    if (!isValid) {
      return;
    }

    setLoading(true);

    if (minutes === 0 && seconds === 0) {
      notification.error("Otp has expired.");
      return;
    }
    if (!otp.otp_phone) {
      notification.error("Please enter phone OTP.");
      return;
    }
    let res;
    try {
      let sendData = {};
      sendData.otp_phone = otp.otp_phone;
      sendData.otpID = otpId || location.state.otpID;
      sendData.device_id = generateRandomID(10);
      sendData.device_type = "web";
      sendData.device_token = generateRandomID(20);
      res = await apiPost(pathObj.verifyLoginOtp, sendData);
      if (res.data.success) {
        const token = res?.data?.results?.token || null;
        const refresh_token = res?.data?.results?.refresh_token || null;
        storeTokens(token, refresh_token)
        notification.success(res.data.message);
        getProfile()
        navigate("/dashboard");
      } else {
        notification.error(res?.data?.message);
      }
    } catch (err) {
      notification.error(res?.data?.message);
    }

    setLoading(false);
  };

  const handleChange = (value, name) => setOtp({ ...otp, [name]: value });

  const handleResendOtp = async () => {
    setLoading(true);
    try {
      if (minutes === 0 && seconds === 0) {
        let sendData = {};
        if (location?.state?.email) sendData.email = location?.state?.email;
        if (location?.state?.mobile) {
          sendData.mobile = location?.state?.mobile;
          sendData.country_code = "355";
        }
        if (location?.state?.username) {
          sendData.username = location?.state?.username;
        }
        sendData.password = location?.state?.password;
        sendData.device_id = generateRandomID(10);
        sendData.device_type = "web";
        sendData.device_token = generateRandomID(20);
        const res = await apiPost(pathObj.loginUser, sendData, {
          params: {
            loginType: "password",
          },
        });
        if (res.data.success === true) {
          setOtpId(res.data?.results?.otpID);
          notification.success(res.data.message);
          setSeconds(59);
          setMinutes(0);
        } else {
          notification.error(res.data.message);
        }
      } else {
        notification.error(t("WAIT_FOR_OTP"));
      }
    } catch (err) {}
    setLoading(false);
  };

  return (
    <div className="flex justify-center grid grid-cols-2 items-center w-full h-screen no-scrollbar">
      <div className="hidden md:flex col-span-1 h-full bg-primary justify-center items-center">
        <div>
          <img className="h-[5rem] cursor-pointer" src="/images/whitelogo.svg" alt="" />
        </div>
      </div>
      <div className="w-full col-span-2 md:col-span-1 h-screen overflow-auto flex flex-col items-center justify-start">
        <Toolbar showBackBtn={true} title={t("OTP")} forceShowBack={true} forceTitleCenter={true}></Toolbar>
        <div className="flex w-full items-center justify-center">
          <div className="mt-5 w-full md:w-[20rem] flex flex-col items-center">
            <div className="sm:w-full">
              {(seconds > 0 || minutes > 0) && (
                <div className="mb-4 d-flex justify-content-between mt-4">
                  <div className="font-medium">
                    {t("OTP_EXPIRING")} {minutes}:{seconds}
                  </div>
                </div>
              )}
              {/* <ErrorMessage message={errors?.otp_email?.message} /> */}
            </div>

            <div className="mb-4">
              <OtpInput
                inputStyle={{
                  border: "1.5px solid var(--card-color)",
                  width: "5rem",
                  background: "transparent",
                  height: "2.4rem",
                  color: "var(--text-color)",
                  fontWeight: "bold",
                  marginRight: ".5rem",
                  outline: "none",
                  borderRadius: "8px",
                }}
                shouldAutoFocus
                isInputNum={true}
                value={otp.otp_phone}
                containerStyle="text-center mt-2"
                onChange={(value) => handleChange(value, "otp_phone")}
                numInputs={4}
                separator={<span> </span>}
              />

              {/* <ErrorMessage message={errors?.otp_phone?.message} /> */}
            </div>

            <div className="w-[95%] mt-5">
              {loading ? (
                <div className="btn btn_theme w-full flex items-center justify-center p-3">
                  <FontAwesomeIcon icon={faCircleNotch} className="text-white text-xl animate-spin" />
                </div>
              ) : (
                <button type="submit" className="btn btn_theme w-full py-3 mb-3 text-white" onClick={handleSubmit}>
                  {t("O_VERIFY")}
                </button>
              )}
            </div>
            <div className="flex gap-1 text-center w-100 mb-2 mt-4">
              <span className="fw-bold">{t("DIDNT_RECEIVE_OTP?")}</span>
              <div onClick={handleResendOtp} className="link text-primary font-medium" style={{ cursor: "pointer" }}>
                {" "}
                {t("RESEND_OTP")}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LoginOtp;
